import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import Track from './Track.jsx';
import Auth from './Auth.jsx';
import './index.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
    this.setState({ componentStack: info && info.componentStack });
  }
  render() {
    if (this.state.error) {
      const msg = this.state.error && (this.state.error.message || String(this.state.error));
      const stack = this.state.error && this.state.error.stack;
      return (
        <div style={{ padding: 24, color: '#f87171', fontFamily: 'monospace', background: '#0f1420', minHeight: '100vh' }}>
          <h2 style={{ color: '#e6ebf5' }}>Error en la aplicación</h2>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{msg}</pre>
          {this.state.componentStack && <pre style={{ whiteSpace: 'pre-wrap', color: '#fbbf24', fontSize: 12 }}>{this.state.componentStack}</pre>}
          {stack && <pre style={{ whiteSpace: 'pre-wrap', color: '#8b96ad', fontSize: 11 }}>{stack}</pre>}
        </div>
      );
    }
    return this.props.children;
  }
}

window.addEventListener('error', (e) => {
  console.error('window.onerror:', e.message, e.error);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('unhandledrejection:', e.reason);
});

const path = window.location.pathname;
const trackMatch = path.match(/^\/track\/([a-f0-9]+)$/);
const confirmMatch = path.match(/^\/confirm\/([a-f0-9]+)$/);
const resetMatch = path.match(/^\/reset\/([a-f0-9]+)$/);

const root = ReactDOM.createRoot(document.getElementById('root'));
if (trackMatch) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Track token={trackMatch[1]} />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else if (confirmMatch) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Auth kind="confirm" token={confirmMatch[1]} />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else if (resetMatch) {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <Auth kind="reset" token={resetMatch[1]} />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
}
